import { PencilSimpleLine } from '@phosphor-icons/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { useAgGridTableContext } from 'core/states';
import { Variant } from 'theme/enums';

import { UpdateJobs } from './UpdateJobs';

export const UpdateJobsButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const { selectedRows, gridApi, deselectAllRows } = useAgGridTableContext();

  const onSubmitSuccess = () => {
    gridApi?.refreshServerSide();
    deselectAllRows();
  };

  return (
    <>
      <Button
        text={t('buttonLabelEdit')}
        onClick={() => setIsOpen(true)}
        variant={Variant.OUTLINED}
        startDecorator={<PencilSimpleLine />}
      />

      <UpdateJobs
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        jobs={selectedRows}
        onSubmitSuccess={onSubmitSuccess}
      />
    </>
  );
};
